import React, { FunctionComponent } from 'react'

import { Container } from './styles'

interface ICenter {
  className?: string
}
const Center: FunctionComponent<ICenter> = ({ children, className }) => {
  return <Container className={className}>{children}</Container>
}

export default Center
